// This file is created automatically by the build process. Do not edit!
export const VERSION_INFO = {
  "version": "0.21.0",
  "name": "slopehelper-erp-frontend",
  "buildDate": "2026-10-24T01:38:30.048Z"
};
